import {InstantDoubleValue} from "../api/model/dataset/InstantDoubleValue";
import {DatasetDataInfoResponse} from "../api/model/dataset/DatasetDataInfoResponse";

export const formatDatasetValue = (dataset:DatasetDataInfoResponse, data: InstantDoubleValue | null | undefined) =>
    data ? data.value.toFixed(dataset?.decimalPlaces ?? 2) : "N/A";